// @ts-nocheck
import React from 'react';
import { withRouter } from 'react-router-dom';
import {
	Form,
	Input,
	Row,
	Col,
	Typography,
	DatePicker,
	Radio,
	Divider,
	Button,
	Select,
} from 'antd';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { LOGGEDIN_USER_DATA } from 'global_config/constant-global';
import { createDonor, updateDonor } from 'services/blood_bank/donor_registration';
import { NumberInput, RegexInput, formatMobileNumber } from 'shared_components/pattern_input';
import HttpCodeMessage from 'shared_components/message_http_status';
import PageTitle from 'shared_components/page_title';
import ProvinceList from 'shared_components/phase2_province';
import CityList from 'shared_components/phase2_city';
import TownList from 'shared_components/phase2_town';
import { fetchBloodTypes } from 'services/blood_bank/blood_types';
// import { User as UserImg } from 'images/bloodbank';
import { FIELD_RULES, selectDefaultOptions, formLabels, messagePrompts } from './constant';
import DonorRegSteps from '../DonorRegSteps';
import './index.css';

const { Text } = Typography;
const { Option } = Select;

// updates
// pabs 27-APR-2023 - updates on issue of blood type, used blood type id instead of name to address the issue

class FillUpForm extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			disabled: true,
			updateInitialValues: {},
			selectedFile: {},
			block: null,
			bloodType: [],
			donorBloodTypeID: '',
		};

		console.log('step 2xx props', props);

		this.formRef = React.createRef();
	}

	async componentDidMount() {
		// const { state } = this.props.location;

		const state = JSON.parse(sessionStorage.getItem('DNR_PERSONAL_INFO'));

		console.log(state);
		const block = state.last_extracted_date === moment().format('YYYY-MM-DD') ? true : false;
		const bloodTypeList = await fetchBloodTypes();

		// added on 27-APR-2023 by pabs issue on blood type
		if (bloodTypeList && state.label === 'UPDATE') {
			const donorBloodType = bloodTypeList.filter(
				item => item.blood_type === state.blood_type_name || state.blood_type,
			);
			this.setState({ donorBloodTypeID: donorBloodType[0].blood_type_id });
		}

		this.setState({
			updateInitialValues: state,
			block: block,
			bloodType: bloodTypeList,
		});
	}

	computeAge = date => {
		const years = Math.floor(moment().diff(date, 'years', true));
		const age = years > 0 ? years : '---';

		return age;
	};

	initCreateDonor = async data => {
		console.log('🚀 ~ file: index.js ~ line 60 ~ FillUpForm ~ initCreateDonor= ~ data', data);
		const { history } = this.props;
		// const { location } = this.props;

		sessionStorage.setItem(
			'DNR_PERSONAL_INFO',
			JSON.stringify({ ...data, label: this.state.updateInitialValues.label }),
		);
		history.push('/bloodbank/donor_registration/step/3');

		// const { updateInitialValues } = this.state;
		// const createdUserResponse = await createDonor(data);
		// if (createdUserResponse.status === 201) {
		// 	const httpMessageConfig = {
		// 		message: messagePrompts.successCreateUser,
		// 		status: createdUserResponse.status,
		// 		duration: 1,
		// 		onClose: () =>
		// 			history.push('/bloodbank/donor_registration/step/3', {
		// 				health_info_id: updateInitialValues.health_info_id,
		// 				donor_id: createdUserResponse.data.donor_id,
		// 				blood_type: createdUserResponse.data.blood_type,
		// 			}),
		// 	};

		// 	HttpCodeMessage(httpMessageConfig);
		// }
	};

	initUpdateDonor = async data => {
		console.log('🚀 ~ file: index.js ~ line 82 ~ FillUpForm ~ initUpdateDonor= ~ data', data);
		const { history } = this.props;
		const { updateInitialValues, block } = this.state;

		sessionStorage.setItem(
			'DNR_PERSONAL_INFO',
			JSON.stringify({
				...data,
				label: updateInitialValues.label,
				block: block,
				custom_fields_list: updateInitialValues.custom_fields_list,
			}),
		);
		history.push('/bloodbank/donor_registration/step/3');

		// const { updateInitialValues, block } = this.state;
		// const updateUserResponse = await updateDonor(data);
		// if (updateUserResponse.status === 200) {
		// 	const httpMessageConfig = {
		// 		message: messagePrompts.successUpdateUser,
		// 		status: updateUserResponse.status,
		// 		duration: 1,
		// 		onClose: () =>
		// 			history.push('/bloodbank/donor_registration/step/3', {
		// 				health_info_id: updateInitialValues.health_info_id,
		// 				donor_id: updateInitialValues.donor_id,
		// 				block: block,
		// 				blood_type: data.blood_type,
		// 			}),
		// 	};
		// 	HttpCodeMessage(httpMessageConfig);
		// }
	};

	onFinish = async formData => {
		const { history } = this.props;
		// const { location } = this.props;
		const { updateInitialValues, block } = this.state;
		const loggedinUser = JSON.parse(sessionStorage.getItem(LOGGEDIN_USER_DATA));

		const isUnchanged =
			updateInitialValues.address_line_1 === formData.address_line_1 &&
			updateInitialValues.address_line_2 === formData.address_line_2 &&
			updateInitialValues.barangay_id === formData.barangay &&
			updateInitialValues.city_id === formData.city &&
			updateInitialValues.province_id === formData.provinces &&
			updateInitialValues.birth_date === formData.birth_date.format('YYYY-MM-DD') &&
			updateInitialValues.donor_id === formData.donor_id &&
			updateInitialValues.first_name === formData.first_name &&
			updateInitialValues.middle_name === formData.middle_name &&
			updateInitialValues.last_name === formData.last_name &&
			updateInitialValues.gender === formData.gender &&
			updateInitialValues.mobile_no === formData.mobile_no &&
			updateInitialValues.email_address === formData.email_address &&
			updateInitialValues.suffix === formData.suffix &&
			updateInitialValues.blood_type_name === formData.blood_type;

		const payload = {
			...formData,
			// image_location:`images/donor/${imgprop.imageName}`,
			image_location: '/test/',
			birth_date: formData.birth_date.format('YYYY-MM-DD'),
		};

		if (formData.donor_id) {
			console.log('update', isUnchanged);

			if (isUnchanged) {
				console.log('unchanged');
				sessionStorage.setItem(
					'DNR_PERSONAL_INFO',
					JSON.stringify({
						...payload,
						label: this.state.updateInitialValues.label,
						block: block,
						custom_fields_list: updateInitialValues.custom_fields_list,
						isUnchanged: true,
					}),
				);
				history.push('/bloodbank/donor_registration/step/3');

				// this.props.history.push('/bloodbank/donor_registration/step/3', {
				// 	...payload,
				// 	health_info_id: updateInitialValues.health_info_id,
				// 	donor_id: updateInitialValues.donor_id,
				// 	label: location.state.label,
				// 	blood_type: this.state.donorBloodTypeID,
				// });
			} else {
				console.log('changed');
				// if initial value of blood type was not change
				if (updateInitialValues.blood_type_name === formData.blood_type) {
					const donorBloodType = this.state.bloodType.filter(
						item => item.blood_type === payload.blood_type,
					);
					this.setState({ donorBloodTypeID: donorBloodType[0].blood_type_id });
				} else {
					this.setState({ donorBloodTypeID: formData.blood_type });
				}

				await this.initUpdateDonor({
					...payload,
					is_active: 1,
					last_updated_by: loggedinUser.userID,
					blood_type: this.state.donorBloodTypeID,
				});
			}

			return;
		} else {
			await this.initCreateDonor({
				...payload,
				created_by: loggedinUser.userID,
			});
		}
	};

	onProvinceChange = () => {
		this.formRef.current.setFieldsValue({
			city: null,
			barangay: null,
			address_line_1: null,
			address_line_2: null,
		});
	};

	onCityChange = () => {
		this.formRef.current.setFieldsValue({
			barangay: null,
			address_line_1: null,
			address_line_2: null,
		});
	};

	onDateChange = date => {
		const { setFieldsValue } = this.formRef.current;
		const age = this.computeAge(date);

		setFieldsValue({ age });
	};

	handleChange = event => {
		const time = new Date().getTime();
		const imgprop = { id: time, imageName: event.target.files[0].name };

		this.setState({
			imgprop,
		});
	};

	mobileNoInput = e => {
		const formattedMobileNumber = formatMobileNumber(e.target.value);
		this.formRef.current.setFieldsValue({ mobile_no: formattedMobileNumber });
	};

	render() {
		const state = JSON.parse(sessionStorage.getItem('DNR_PERSONAL_INFO'));
		// const { state } = this.props.location;
		console.log('🚀 ~ file: index.js ~ line 198 ~ FillUpForm ~ render ~ state', state);
		const { bloodType } = this.state;

		const BloodTypeOptions = bloodType.map(item => (
			<Option key={item.blood_type_id} value={item.blood_type_id}>
				{item.blood_type}
			</Option>
		));

		return (
			<div>
				<PageTitle pageTitle="DONOR REGISTRATION" />
				<DonorRegSteps activeIndex={2} />
				<div className="space-y-md"></div>
				<Form
					initialValues={{
						...state,
						age: state.birth_date ? this.computeAge(state.birth_date) : null,
						birth_date: state.birth_date ? moment(state.birth_date, 'YYYY-MM-DD') : null,
						mobile_no: state.mobile_no ? state.mobile_no : null,
						// last_extracted: state.last_extracted ? moment(state.last_extracted, 'YYYY-MM-DD') : null,
						provinces: state.province_id || state.provinces,
						city: state.city_id || state.city,
						barangay: state.barangay_id || state.barangay,
						blood_type_name: state.blood_type_name ? state.blood_type_name : null,
					}}
					ref={this.formRef}
					onFinish={this.onFinish}
					className="donor-rigistration-clr-fillup-form"
					layout="vertical"
					style={{ marginTop: 10 }}
				>
					<div className="donor-registration-title">
						<Text strong>PERSONAL INFORMATION</Text>
					</div>

					<div className="container">
						<div className="left-form">
							{/* <Row style={{ marginTop: 10 }}>
								<img src={imgprop ? require(`images/donor/${imgprop.imageName}`) : require(`images/donor/defaulticon.png`)} alt="logo" name='sample' style={{ height: 140, width: 140 }} />
								<Form.Item name="img" rules={FIELD_RULES.firstName}>
										<input type="file" onChange={this.handleChange} />
									</Form.Item>
							</Row> */}
							<Form.Item name="donor_id" style={{ display: 'none' }}>
								<Input />
							</Form.Item>
							<Form.Item label="FIRST NAME" name="first_name" rules={FIELD_RULES.firstName}>
								<RegexInput
									regex={/[A-Za-z0-9-. ]/}
									autoFocus
									maxLength={50}
									disabled={state.donor_id}
								/>
							</Form.Item>
							<Form.Item
								label="MIDDLE NAME"
								name="middle_name"
								// rules={FIELD_RULES.middleName}
							>
								<RegexInput
									regex={/[A-Za-z0-9-. ]/}
									maxLength={15}
									disabled={state.donor_id && state.gender === 'M'}
								/>
							</Form.Item>
							<Row gutter={12}>
								<Col span={18}>
									<Form.Item label="LAST NAME" name="last_name" rules={FIELD_RULES.lastName}>
										<RegexInput
											regex={/[A-Za-z0-9-. ]/}
											maxLength={50}
											disabled={state.donor_id && state.gender === 'M'}
										/>
									</Form.Item>
								</Col>
								<Col span={6}>
									<Form.Item label="SUFFIX" name="suffix">
										<RegexInput
											name="nameSuffix"
											regex={/[A-z0-9 -]/}
											maxLength={5}
											style={{ marginTop: 1 }}
											disabled={state.donor_id}
										/>
									</Form.Item>
								</Col>
								<Col span={24}>
									<Form.Item
										label="Blood Type"
										name="blood_type"
										rules={FIELD_RULES.blood_type_name}
										initialValue={state.blood_type_name}
									>
										<Select
											style={{ width: '100%' }}
											allowClear
											// disabled={state.donor_id}
										>
											{BloodTypeOptions}
										</Select>
									</Form.Item>
								</Col>
								<Col span={18}>
									<Form.Item
										name="birth_date"
										label={formLabels.dateOfBirth}
										rules={FIELD_RULES.dateOfBirth}
									>
										<DatePicker
											placeholder="MM-DD-YYYY"
											format="YYYY-MM-DD"
											onChange={this.onDateChange}
											style={{ width: '100%' }}
											disabled={state.donor_id}
										/>
									</Form.Item>
								</Col>
								<Col span={6}>
									<Form.Item name="age" label={formLabels.age} rules={FIELD_RULES.age}>
										<Input disabled style={{ textAlign: 'center' }} />
									</Form.Item>
								</Col>
							</Row>
						</div>

						<div className="divider">
							<Divider className="line" type="vertical" />
						</div>

						<div className="center-form">
							<Form.Item label="CONTACT NUMBER" name="mobile_no" rules={FIELD_RULES.contactNumber}>
								<NumberInput
									addonBefore="+ 63"
									maxLength={12}
									regex={/[0-9-. ]/}
									onChange={this.mobileNoInput}
								/>
							</Form.Item>
							<Form.Item name="email_address" label="EMAIL" rules={FIELD_RULES.emailAddress}>
								<Input maxLength={100} />
							</Form.Item>
							<Form.Item label="PATIENT'S GENDER" name="gender" rules={FIELD_RULES.gender}>
								<Radio.Group buttonStyle="solid" disabled={state.donor_id}>
									<Radio.Button value="M" style={{ width: 100, textAlign: 'center' }}>
										MALE
									</Radio.Button>
									<Radio.Button value="F" style={{ width: 100, textAlign: 'center' }}>
										FEMALE
									</Radio.Button>
								</Radio.Group>
							</Form.Item>
							{/* <div style={{ marginTop: 15 }}>
									<Form.Item label="LAST DONATION DATE" name="last_extracted">
										<DatePicker
											format="MM-DD-YYYY"
											disabled={state.last_extracted}
											style={{ width: '100%' }}
										/>
									</Form.Item>
								</div> */}
							<div>
								<ProvinceList
									form={this.formRef}
									placeholder={selectDefaultOptions}
									onChange={this.onProvinceChange}
									rules={FIELD_RULES.province}
								/>
							</div>
							<div>
								<Form.Item shouldUpdate>
									{form => {
										return (
											<CityList
												placeholder={selectDefaultOptions}
												provinceValue={form.getFieldValue('provinces')}
												onChange={this.onCityChange}
												rules={FIELD_RULES.provinces}
											/>
										);
									}}
								</Form.Item>
							</div>
						</div>

						<div className="divider">
							<Divider className="line" type="vertical" />
						</div>

						<div className="right-form">
							<Form.Item shouldUpdate>
								{form => {
									return (
										<TownList
											placeholder={selectDefaultOptions}
											cityValue={form.getFieldValue('city')}
											fieldName="barangay"
											initialValue={state.barangay}
										/>
									);
								}}
							</Form.Item>
							<Form.Item
								label="Address Line 1"
								name="address_line_1"
								rules={FIELD_RULES.addr_line_1}
							>
								<Input placeholder="HOUSE NO./UNIT/FLOOR NO. BLDG. NAME" maxLength={100} />
							</Form.Item>
							<Form.Item label="Address Line 2" name="address_line_2" style={{ marginTop: 15 }}>
								<Input placeholder=" Appartment, Unit, Building Floor, etc" maxLength={100} />
							</Form.Item>
						</div>
					</div>
					<Row justify="end" style={{ width: '100%', maxWidth: '1600px', margin: '0 auto' }}>
						<div className="buttons">
							<Link to={'/bloodbank/donor_registration/step/1'}>
								<Text>
									<u>BACK</u>
								</Text>
							</Link>
							<Button type="primary" shape="round" style={{ width: 120 }} htmlType="submit">
								NEXT STEP
							</Button>
						</div>
					</Row>
				</Form>
			</div>
		);
	}
}

export default withRouter(FillUpForm);
